export * from '@fhs/routing/src/routes/(drawer)/account/other-terms';
export { default } from '@fhs/routing/src/routes/(drawer)/account/other-terms';
